app.WebhookList = app.AbstractCollection.extend({
  model: app.Webhook,

  url() {
    return '/api/v2/webhooks';
  },
});
